import { Pipe, PipeTransform } from '@angular/core';
import { FilterableTraceSource, Trace, isInboundTraceSource } from '../models/tracer.model';

@Pipe({
  name: 'getTracesBySource',
})
export class GetTracesBySourcePipe implements PipeTransform {
  transform(
    traces: Trace[],
    uniqueTracesByProviders: Trace[],
    shouldTracesBeGrouped: boolean,
    source: FilterableTraceSource
  ): Trace[] {
    // The "json-api" pipe argument also accepts source="sidecar" rows —
    // the sidecar produces the same inbound traces the legacy in-process
    // tracer used to write under "json-api".
    const matches = (s: string) => (source === 'json-api' ? isInboundTraceSource(s) : s === source);

    if (shouldTracesBeGrouped) {
      return uniqueTracesByProviders?.filter(item => matches(item.source));
    } else {
      return traces?.filter(item => matches(item.source));
    }
  }
}
